import React from "react";
import './Event.css';

import { renderIcon } from "../../utils";

import { Link } from "react-router-dom";



const Event = ({ event }) => {

    return (

        <div className="event-item">

            <img src={event.image} alt={event.title} /> {/* Event Image */}

            <div className="content">

                <div className='top-icon'>
                    <span></span>
                    <div className='icon'>{renderIcon(event.title)}</div> {/* Event Icon */}
                    <span></span>
                </div>

                {/* Link to the individual Event page */}
                <Link
                    to={{
                        pathname: '/Events/' + event.title,  // Navigate to the specific Event page
                    }}
                    location = {{event}}  // Passing Event details to the linked page
                    className="main-heading"
                    state= {event}> 
                    {event.title} {/* Event Title */}
                </Link>

            </div>

        </div>
    );
};

export default Event;